import { useQuery } from '@tanstack/react-query';

import { apiGet } from '@/lib/http/client';
import {
  portfolioQueryKeys,
  portfolioSnowflakeCredentialsUrl,
} from '@/lib/portfolio/api';
import type { SnowflakeDirectoryCredential } from '@/lib/portfolio/snowflake-types';

export function useSnowflakeCredentials(portfolioId: number) {
  return useQuery<SnowflakeDirectoryCredential[]>({
    queryKey: portfolioQueryKeys.snowflakeCredentials(portfolioId),
    queryFn: () =>
      apiGet<SnowflakeDirectoryCredential[]>(
        portfolioSnowflakeCredentialsUrl(portfolioId)
      ),
    enabled: Number.isFinite(portfolioId),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
